import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'dutch-love-coverletter',
  templateUrl: './dutch-love.coverletter.component.pug',
  styleUrls: ['./dutch-love.coverletter.component.styl']
})
export class CoverletterDutchLoveComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Dutch Love';
		this.subtitle='Human Resources';
		this.titleService.setTitle("Liam Hogan's | Dutch Love | Cover Letter");
		this.tirtitle='';
		this.company='Dutch Love'; 
	}

}
